// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js!../../../components/library/style/breakpoint.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nWZzH6DyC6rjurFHuoVj {
    margin-left: auto;
    margin-top: 16px;
}

.reJ8ua8QrKj1dam4ercf {
    margin-top: 16px;
}

.c3esRW1NjQm2kfK2gvo6 {
    position: relative;
}

.ZbQzHYJY_Smh8nthC7Ww {
    position: absolute;

    display: flex;
    flex-direction: column;
    align-items: flex-start;
    row-gap: 8px;

    width: 100%;
    box-sizing: border-box;
    padding: 4px;

    background-color: white;
    box-shadow: 0 4px 25px rgba(0, 0, 0, 0.05);
}

.ZbQzHYJY_Smh8nthC7Ww button {
    width: 100%;
    height: 42px;
    font-weight: 400;
    font-size: 16px;
    text-align: left;
}

.ZbQzHYJY_Smh8nthC7Ww button:hover {
    background-color: #F8FAFF;
}
`, "",{"version":3,"sources":["webpack://./src/views/Confirmation/ConfirmationSociety/ConfirmationSociety.module.css"],"names":[],"mappings":"AAGA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;;IAElB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;;IAEZ,WAAW;IACX,sBAAsB;IACtB,YAAY;;IAEZ,uBAAuB;IACvB,0CAA0C;AAC9C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":["@value breakpoints: \"components/library/style/breakpoint.css\";\n@value desktop, laptop, tablet, mobile, mobile-xs from breakpoints;\n\n.next {\n    margin-left: auto;\n    margin-top: 16px;\n}\n\n.previous {\n    margin-top: 16px;\n}\n\n.relative {\n    position: relative;\n}\n\n.legal {\n    position: absolute;\n\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    row-gap: 8px;\n\n    width: 100%;\n    box-sizing: border-box;\n    padding: 4px;\n\n    background-color: white;\n    box-shadow: 0 4px 25px rgba(0, 0, 0, 0.05);\n}\n\n.legal button {\n    width: 100%;\n    height: 42px;\n    font-weight: 400;\n    font-size: 16px;\n    text-align: left;\n}\n\n.legal button:hover {\n    background-color: #F8FAFF;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"breakpoints": `"components/library/style/breakpoint.css"`,
	"desktop": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["desktop"]}`,
	"laptop": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["laptop"]}`,
	"tablet": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["tablet"]}`,
	"mobile": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["mobile"]}`,
	"mobile-xs": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["mobile-xs"]}`,
	"next": `nWZzH6DyC6rjurFHuoVj`,
	"previous": `reJ8ua8QrKj1dam4ercf`,
	"relative": `c3esRW1NjQm2kfK2gvo6`,
	"legal": `ZbQzHYJY_Smh8nthC7Ww`
};
export default ___CSS_LOADER_EXPORT___;
